<script setup>
// @ts-check

import { invalidatePayslipInput } from '@/api/payslipInputs'
import CheckField from '@/components/fields/CheckField.vue'
import ConfirmDialog from '@/components/dialogs/ConfirmDialog.vue'
import { useToasts } from '@/core/composables/useToasts'
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'

const props = defineProps({
  payslipInputId: {
    type: Number,
    required: true
  }
})

const emit = defineEmits(['voided', 'error'])

defineOptions({
  name: 'SalaryVoidingDialog'
})

const { t } = useI18n()
const { addSuccessToast, addDangerToast } = useToasts()

const isConfirmed = ref(false)

const voidSalary = async ({ close }) => {
  try {
    await invalidatePayslipInput(props.payslipInputId)
    addSuccessToast({ content: t('salary.success.void') })
    emit('voided')
  } catch (error) {
    addDangerToast({ content: t('salary.errors.void') })
    console.error(error)
    emit('error')
  } finally {
    close()
  }
}
</script>

<template>
  <ConfirmDialog
    :title="t('salary.actions.void')"
    :disabled="!isConfirmed"
    @action="voidSalary"
  >
    <div class="flex flex-col gap-y-5">
      <p class="font-semibold">
        {{ t('salary.info.voiding') }}
      </p>

      <CheckField v-model="isConfirmed">
        {{ t('salary.confirm.void') }}
      </CheckField>
    </div>

    <template #action>
      {{ t('salary.actions.void') }}
    </template>
  </ConfirmDialog>
</template>
